'use strict';

var buildSimpleValidator = require('./helpers/build-simple-validator');

module.exports = buildSimpleValidator(function (value, validationOptions) {
  return value.length <= validationOptions.maxLength;
},
// eslint-disable-next-line max-len
function (value, validationOptions) {
  return 'Maximum ' + validationOptions.maxLength + ' characters.';
}, ['maxLength']);